import React, { useEffect, useState } from "react";
import axios from "axios";
import { BaseUrlApi, ErrorMessage } from "src/lib/api";
import { toast } from "sonner";
import { Eye } from "lucide-react";
import { Button } from "src/components/ui/button";
import { useLanguage } from "src/context/LanguageContext";
import { SubLessonData } from "src/lib/languages";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTrigger,
} from "src/components/ui/drawer";
import { AnimatePresence } from "framer-motion";
import { motion } from "framer-motion";
import QuestionCard from "src/components/Quiz/question-card";

export const DrawerSurveyShowAnswer = ({ surveyData }) => {
  const { language } = useLanguage();
  const t = SubLessonData[language] || SubLessonData["en"];
  const [open, setOpen] = useState(false);

  return (
    <Drawer
      open={open}
      onOpenChange={(value) => {
        setOpen(value);
      }}
    >
      <DrawerTrigger asChild>
        <Button variant="ghost" size="icon">
          <Eye />
        </Button>
      </DrawerTrigger>
      <DrawerContent dir={language === "ar" ? "rtl" : "ltr"}>
        <div className="h-[calc(100vh-2rem)] max-w-7xl w-full mx-auto overflow-auto hide-scrollbar">
          <DrawerHeader className="flex items-center justify-between flex-wrap gap-4">
            <div className="w-full sm:w-fit">
              <p className="font-bold text-2xl pt-5" id="category">
                Survay Answers “{surveyData?.title || "---"}”
              </p>
              <p className="font-medium text-sm">
                {t.reviewTestForStudent} Review{" "}
              </p>
            </div>
            <div className="flex items-center gap-2 w-full sm:w-fit">
              <DrawerClose asChild>
                <Button
                  variant="outline"
                  className="w-full sm:w-fit h-10 rounded-xl border-2 border-blue-600 text-blue-600 hover:text-blue-500"
                >
                  {t.close}
                </Button>
              </DrawerClose>
            </div>
          </DrawerHeader>
          <div className="p-4">
            <AnimatePresence>
              {surveyData.questions.map((question, index) => {
                return (
                  <motion.div
                    key={question.id}
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    className="mb-4"
                  >
                    <QuestionCard
                      question={question}
                      isEditMode={false}
                      isShowMode={true}
                      showCorrectAnswers={true}
                      language={language}
                      removeQuestion={() => {}}
                      onAnswerSelect={(optionId) => {}}
                      isSurvey={true}
                    />
                  </motion.div>
                );
              })}
            </AnimatePresence>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
